import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'
import { VenueEntity } from '@/api/venue'

export { BaseResponse, ResponseStatus }

export interface SettingResponse {
  games: SupportedGame[]
  avatars: SupportedAvatar[]
  applicationVenue: VenueEntity
  regions: RegionInfo[]
}

export interface SupportedGame {
  code: string
  name: string
  icon: string
  banner: string
  background: string
  themeColor: string
}

export interface SupportedAvatar {
  url: string
}

export interface RegionInfo {
  code: string
  name: string
  idd: string
}

export class ConfigAPI {
  public static API_PREFIX = '/config/v1'

  public static getSettings(): AxiosPromise<BaseResponse<SettingResponse>> {
    return axios.get(`${this.API_PREFIX}/settings`)
  }

  public static getSuggestedRegion(): AxiosPromise<BaseResponse<RegionInfo>> {
    return axios.get(`${this.API_PREFIX}/suggested-region`)
  }
}
